
import Shoecomp from "./Components/Shoecomp";
import './App.css'



function App() {

  return <div>



    <Shoecomp />

  </div>;
}

export default App;
